<template>
  <div id="scroll-container-app-wrapper" class="d-flex flex-column main-container">
    <!-- HEADER -->
    <slot name="header" />

    <!-- CONTENT -->
    <slot name="body" />

    <!-- FOOTER MENU AND NAV-->
    <slot name="footer" />

    <slot name="modals" />
  </div>
</template>

<script>
export default {
  name: 'SduiScrollableWrapper',
}
</script>

<style scoped lang="scss">
// Needed so scrolling container can correctly calculate remaining height. This is the fallback if
// dvh units are not supported by the browser.
#scroll-container-app-wrapper,
.main-container {
  min-height: calc(100vh - env(safe-area-inset-bottom) - env(safe-area-inset-top));
  max-height: calc(100vh - env(safe-area-inset-bottom) - env(safe-area-inset-top));
}

// iOS specifics because mobile safari behaves differently
@supports (-webkit-touch-callout: none) {
  // overwrite existing classes for iOS
  #scroll-container-app-wrapper {
    min-height: unset;
  }

  .main-container {
    min-height: -webkit-fill-available;
  }

  #scroll-container-app-wrapper,
  .main-container {
    max-height: calc(100vh - env(safe-area-inset-bottom) - env(safe-area-inset-top));
  }

  // if supported, use svh unit
  @supports (max-height: 100svh) {
    #scroll-container-app-wrapper,
    .main-container {
      max-height: calc(100svh - env(safe-area-inset-bottom) - env(safe-area-inset-top));
    }
  }
}

// if supported: dvh unit on non-iOS (because iOS behaves differently)
@supports (not (-webkit-touch-callout: none)) and (max-height: 100dvh) {
  // needed so scrolling container can correctly calculate remaining height
  #scroll-container-app-wrapper,
  .main-container {
    min-height: 100dvh;
    max-height: 100dvh;
  }
}
</style>
